module.exports = __webpack_public_path__ + "img/blog-card-underline.9df3e45b.svg";